import TicketPriorityProvider from './TicketPriorityContext';
import TicketPriority from "./TicketPriority"

let Index = () => {
    return (
        <TicketPriorityProvider>
            <TicketPriority />
        </TicketPriorityProvider>
    )
}

export default Index;